export default __webpack_public_path__ + "static/media/musicapp.37349f38.png";